module.exports = __webpack_public_path__ + "img/lampion-boule-papier.14f5bbc.png";